module.exports = __webpack_public_path__ + "img/sub-categories.aad632dd.png";